// extracted by mini-css-extract-plugin
export default {"heading":"Targeting_heading__wNUH7","wrapper":"Targeting_wrapper__+y37f"};